// extracted by css-extract-rspack-plugin
var _1 = "i12ej0va4oFUicGx";
export { _1 as "header" }
